import routerOptions0 from "/builds/sites/wnhub-general-client/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/builds/sites/wnhub-general-client/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}